import { useState } from "react";
import { api } from "../api/client.js";

export function ForgotPasswordForm({ audience, onSuccess, onGoToLogin }) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post(`/api/${audience}/auth/request-password-reset`, { email });
    } finally {
      setSubmitting(false);
      onSuccess();
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#2C2C2C", marginBottom: 4 }}>
        El. paštas
      </label>
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-full px-3 py-2 mb-4 border border-gray-200 rounded-lg text-sm"
      />

      <button
        type="submit"
        disabled={submitting}
        className="w-full px-4 py-2 text-sm font-semibold rounded-lg bg-ral3000 text-white hover:bg-ral3000-dark disabled:opacity-60"
      >
        {submitting ? "Siunčiama..." : "Siųsti atstatymo nuorodą"}
      </button>

      <div style={{ textAlign: "center", marginTop: 16, fontSize: 13, color: "#383853" }}>
        <button type="button" onClick={onGoToLogin} style={{ color: "#735DFF", fontWeight: 600, background: "none", border: 0, cursor: "pointer" }}>
          Grįžti į prisijungimą
        </button>
      </div>
    </form>
  );
}
